import { Link } from 'react-router-dom';

export default function ArticleSidebar() {
  const relatedArticles = [
    { label: 'Litbuy Spreadsheet Resource Center', to: '/' },
    { label: 'Beginner Guide to Litbuy Spreadsheet', to: '/litbuy-spreadsheet-beginner-guide' },
    { label: 'Litbuy Spreadsheet Safety & Security', to: '/litbuy-spreadsheet-security-guide' },
    { label: 'Best Litbuy Spreadsheet Templates', to: '/best-litbuy-spreadsheet-templates' },
    { label: 'Litbuy Spreadsheet vs Traditional Tools', to: '/litbuy-spreadsheet-vs-traditional' },
    { label: 'Litbuy Spreadsheet Tips & Tricks', to: '/litbuy-spreadsheet-tips-and-tricks' },
  ];

  return (
    <aside className="lg:sticky lg:top-24">
      <div className="rounded-xl bg-background-100 border border-background-200/70 p-6">
        <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Related Articles</h4>
        <div className="w-8 h-px bg-accent-400 mb-4"></div>
        <ul className="space-y-3">
          {relatedArticles.map((article) => (
            <li key={article.label}>
              <Link
                to={article.to}
                className="text-sm text-foreground-600 transition-colors duration-150 cursor-pointer hover:text-primary-600 leading-snug block"
              >
                {article.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-6 rounded-xl bg-primary-50 border border-primary-200/40 p-6">
        <p className="text-sm font-medium text-primary-800">Ready to explore Litbuy Spreadsheet?</p>
        <p className="text-xs text-primary-600 mt-2 leading-relaxed">
          Visit the main website to access the full platform with all features, templates, and tools.
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="whitespace-nowrap mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-all duration-200 cursor-pointer hover:bg-primary-600 w-full justify-center"
        >
          Visit Main Website
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-xs"></i>
          </span>
        </a>
      </div>
    </aside>
  );
}